import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { capitalizeFirstLetter } from 'shared/utils/capitalizeFirstLetter'
import { getChartAttr } from 'shared/utils/chartConfig'
import { SOURCE_NAMES } from 'modules/Charts/consts'

import { IFactSourcesProps } from './FactSources.props'

import './FactSources.scss'

const FactSources: FC<IFactSourcesProps> = ({ factSources }) => (
  <>
    <div className="fact-sources sticky">
      <div className="fact-sources-source" />
      {factSources.map((item, index) => {
        const chartMeta = getChartAttr(item.chart)

        return (
          <div
            className={cn('fact-sources-source', `fact-sources-source--${factSources.length}`)}
            key={`factSource__${index}`}
          >
            <div className={`${chartMeta?.icon || ''}`} />
            <div className="fact-sources-source__title">
              <b>{chartMeta?.name || item.chart}</b>
              <div>
                {capitalizeFirstLetter(item.configuration)}&nbsp;{item.country_code}&nbsp;{item.import_limit}
              </div>
            </div>
          </div>
        )
      })}
    </div>
    <div className="fact-sources">
      <div className="fact-sources-source">
        <b className="fact-sources-source__title">Source</b>
      </div>
      {factSources.map((item, index) => (
        <div
          className={cn('fact-sources-source', `fact-sources-source--${factSources.length}`)}
          key={`factSourceDetails__${index}`}
        >
          <b className="fact-sources-source__subtitle">{SOURCE_NAMES[item.origin]}</b>
        </div>
      ))}
    </div>
  </>
)

export default FactSources
